import React from 'react';
import Form from './Form';

export default function EditGeneralSettings() {
    return (
        <Form></Form>
    )
}
